// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23Cam","content":"styles_content__2dJXT"};